import { useEffect, useState, useContext } from "react";
import { Outlet, useParams } from "react-router-dom";
import { Box, ButtonGroup, Button, Grid2 as Grid, Typography, Grow } from "@mui/material"
import { useEvent } from "../context/eventContext";
import { get_Event_byID, get_event_status_live } from "../FirebaseUtils/dbEvent";
import { get_match_live } from "../FirebaseUtils/dbMatch";
import { get_Cow_byID } from "../FirebaseUtils/dbCow";
import { getSelectedElement } from "../utils/ui_utils";
import { getAwardLabel } from "../definitions/match";
import { getCross } from "../definitions/cow";

export const PublicEventScreen = () => {

    const { selEvent, setSelEvent } = useEvent()

    const { event_id } = useParams()
    const [event_status, setEventStatus] = useState({})
    useEffect(() => {
        const initData = async () => {
            console.log("INIT DATA")
            if (event_id) {
                const ev = await get_Event_byID(event_id)
                if (ev) {
                    setSelEvent(ev)
                }
            }
        }
        initData()

    }, [event_id])

    useEffect(() => {
        document.title = 'ShowTime ANAFIBJ - gestione gare';
        let unsubscribe = () => {

        }


        const ev_callback = (cur_session) => {
            console.log("CUR SESSION", cur_session)
            if (cur_session) {

                unsubscribe = setEventStatus(cur_session)
            }
        }
        const initLive = async () => {
            const es = await get_event_status_live(selEvent.id, ev_callback)
        }
        initLive()
        return () => {
            try {
                unsubscribe()
            } catch (err) {

            }
        }

    }, [selEvent])

    return (
        <Box sx={{cursor: 'none'}}>
            <EventHeader event_status={event_status} />
            {event_status.cur_match?.result_list?.filter(a => checkVisibility(event_status.cur_match?.award_list, a)).map((r, k) => (
                <ResultList result_data={r} key={k} event_id={selEvent.id} label_list={event_status.cur_match.award_label_list} />
            ))}
        </Box>
    )
}


const checkVisibility = (award_list, result) => {
    console.log("check", award_list, result)
    const a = getSelectedElement(result.id, award_list, 'id')
    if (a  && a.hide_from_screen){
        return false
    }
    return true
}


const ResultList = ({ result_data, event_id, label_list }) => {

    const [real_cows, setRC] = useState([])

    useEffect(() => {

        const getRClist = async (size) => {

            console.log(result_data)
            const light_list = result_data.cow_list.slice(0, size)
            console.log("LIGHT LIST", light_list)
            const l_list = await Promise.all(light_list.map(async (i, k) => {
/*                 let label = `${i.position_id + 1}ª classificata`
                const p_label = label_list.filter(e => e.position === i.position_id+1)
                console.log("PLABEL", p_label, label_list)
                if (p_label.length>0 && p_label[0].award_name){
                    label = p_label[0].award_name
                } */
                const label = getAwardLabel(i.position_id, label_list)
                console.log("ONE COW", i.cow, label, {position: i.position_id+1})
                const real_cow = await get_Cow_byID(event_id, i.cow?.id)
                return { cow: real_cow, label: label }
            }))
            setRC([])
            setTimeout(() => {
                setRC(l_list)
            }, 300)

        }
        const getRealCow = async () => {

            try {

                const real_cow = await get_Cow_byID(event_id, result_data.cow_list[0].cow?.id)
            setRC([])
            setTimeout(() => {
                setRC([{ cow: real_cow, label: result_data.award_name }])
            }, 500)
            } catch (err) {
                console.log("ERR", err)

            }

        }
        if (result_data.has_position === true) {
            getRClist(3)
        } else {
            getRealCow()

        }
    }, [result_data])


    return (
        <>
            <Box sx={{ m: 2 }}>

                {real_cows.map((c, k) => (

                    <OneCow key={k} result_label={c.label} cow={c.cow} index={k} />
                ))}
            </Box>
        </>
    )

}

const OneCow = ({ cow, result_label, index }) => {
    return (
        <>
            <Grow in={true} style={{ transformOrigin: '0 0 0' }}
                {...({ timeout: 500 + index * 1000 })}>

                <Grid container flexDirection={"column"} sx={{ backgroundColor: 'lightblue', mt: 3, p: 1, ml: index * 2, boxShadow: '4px 4px black', borderRadius: 2 }}>
                    <Grid container sx={{ borderBottom: '1px solid black', fontSize: '30px' }}>
                        {result_label}
                    </Grid>
                    <Grid container sx={{ fontSize: '50px', fontWeight: 'bold' }}>
                        <Grid size={1} sx={{ textAlign: "center" }}>
                            {cow?.catalog_id}
                        </Grid>
                        <Grid size={"grow"}>
                            {cow?.name}
                        </Grid>
                    </Grid>
                    <Grid container sx={{  fontSize: '30px' }}>
                        {getCross(cow)}
                    </Grid>
                    <Grid container sx={{ borderTop: '1px solid black', fontSize: '20px' }}>
                        {cow?.property?.name}
                    </Grid>
                </Grid>
            </Grow>
        </>
    )
}


const LOGO_PATH = "/logo-ANAFIBJ-600.png"

const EventHeader = ({ event_status }) => {
    const { selEvent } = useEvent()
    let logo = []
    if (selEvent.screen_show_logo && selEvent.screen_show_customlogo && selEvent.logo){
        logo = [LOGO_PATH, selEvent.logo]
    }else if (selEvent.screen_show_customlogo && selEvent.logo){
        logo = [selEvent.logo, selEvent.logo]
    }else if (selEvent.screen_show_logo){
        logo = [LOGO_PATH, LOGO_PATH]
    }
    return (
        <Grid container spacing={2} alignItems={"center"} sx={{ mt: 2 }}>
            <Grid sx={{ textAlign: 'center' }} size={2}>
                <Typography
                    sx={{ width: '100%', fontSize: '', fontWeight: 'bold', color: '#8fb5d7' }}
                >
                    {logo[0] &&
                    <img src={logo[0]} width="150px" />
                    }
                </Typography>

            </Grid>
            <Grid size="grow">
                {selEvent?.event_name &&
                    <>
                        <Grid size="grow" sx={{ fontSize: 'clamp(2rem, 10vw, 2.15rem)', textAlign: 'center', backgroundColor: 'lightblue', fontWeight: 'bold' }}>
                            {selEvent?.event_name}
                        </Grid>
                        <Grid size="grow" sx={{ fontSize: 'clamp(3rem, 10vw, 3.15rem)', textAlign: 'center', backgroundColor: 'lightblue', fontWeight: 'bold', mt: 1 }}>
                            {event_status.cur_match?.match_name}
                        </Grid>
                        <Grid size="grow" sx={{ fontSize: 'clamp(1.5rem, 10vw, 1.55rem)', textAlign: 'center', backgroundColor: 'lightblue', fontWeight: 'bold', mt: 1 }}>
                            {event_status.cur_match?.match_description}
                        </Grid>
                    </>
                }
            </Grid>
            <Grid size={2} sx={{ textAlign: 'center' }}>
                <Typography
                    sx={{ width: '100%', fontSize: '', fontWeight: 'bold', color: '#8fb5d7' }}
                >
                    {logo[1] &&
                    <img src={logo[1]} width="150px" />
                    }
                </Typography>
            </Grid>
        </Grid>
    )
}